let collection: Promise<string | undefined> | undefined;

/** A browser-provided abuse signal. Unavailable collection never blocks signup. */
export function getDeviceFingerprint(): Promise<string | undefined> {
  if (!collection) collection = collect();
  return collection;
}
async function collect(): Promise<string | undefined> {
  let timeout: ReturnType<typeof setTimeout> | undefined;
  try {
    return await Promise.race([
      (async () => {
        const { default: FingerprintJS } = await import('@fingerprintjs/fingerprintjs');
        const agent = await FingerprintJS.load();
        const { visitorId } = await agent.get();
        const value = visitorId?.trim();
        return value && value.length <= 128 ? value : undefined;
      })(),
      new Promise<undefined>(resolve => { timeout = setTimeout(() => resolve(undefined), 3000); }),
    ]);
  } catch { return undefined; }
  finally { if (timeout) clearTimeout(timeout); }
}
